"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Img = require("./Img");

var _grid = require("@rebass/grid");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    background-image: url(", ");\n    background-repeat: repeat;\n    background-position: center center;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    color: white;\n    a {\n      color: white;\n      text-decoration: underline;\n    }\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    padding: 2rem 0; \n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  padding: 0 0 1.5rem 0;\n  \n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    margin-top: 2rem;\n  }\n\n  ", "\n\n  ", "\n\n\n  &:first-of-type {\n    margin-top: 0;\n  }\n\n  ", "\n\n  ", "\n\n  .section__bg {\n    display: block;\n    width: 100%;\n    height: 100%;\n    background-position: center center;\n    background-size: cover;\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    object-fit: cover;\n    object-position: left center;\n    font-family: \"object-fit: cover; object-position: center\";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Section = function Section(props) {
  return _react.default.createElement(StyledSection, _extends({
    as: "section",
    image: props.sizes,
    bg: props.bg,
    layout: props.layout,
    bgAlign: props.bgAlign
  }, props), props.sizes && _react.default.createElement(_Img.Img, {
    sizes: props.sizes,
    style: {
      position: 'absolute',
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      height: '100%',
      width: '100%',
      objectFit: 'cover',
      objectPosition: 'center',
      fontFamily: "\"object-fit: cover; object-position: left center\""
    }
  }), props.bg && _react.default.createElement(_Img.Img, {
    className: "section__bg",
    src: props.bg,
    style: {
      fontFamily: "\"object-fit: cover; object-position: left center\"",
      objectFit: 'cover',
      objectPosition: 'center'
    }
  }), props.children);
};

var _default = Section;
exports.default = _default;
var StyledSection = (0, _styledComponents.default)(_grid.Box)(_templateObject(), function (props) {
  return props.bg || props.image ? (0, _styledComponents.css)(_templateObject2()) : null;
}, function (props) {
  return props.layout && props.layout.text_mode === 'light' && (0, _styledComponents.css)(_templateObject3());
}, function (props) {
  return props.layout && props.layout.background === 'Color' && (0, _styledComponents.css)(_templateObject4(), props.layout.background_color);
}, function (props) {
  return props.layout && props.layout.background === 'Image' && (0, _styledComponents.css)(_templateObject5(), props.layout.background_image.url);
});